<script setup lang="ts">
import type { LoginCredentials } from '@/types'
import { computed } from 'vue'
import { ref } from 'vue'
import { useToast } from 'vue-toast-notification'
import { useI18n } from 'vue-i18n'

const toast = useToast({ position: 'bottom', queue: true, duration: 1000 })
const { t } = useI18n()

const props = defineProps<{
  username?: string
  password?: string
}>()

const model = ref<LoginCredentials>({ username: '', password: '' })

const emitters = defineEmits<{
  doLogin: [credentials: LoginCredentials]
}>()

const validInput = computed(() => {
  let username = model.value.username
  let password = model.value.password

  if (username && password) {
    let result = validateEmail(username) && password.length >= 3
    return result
  }

  return false
})

if (props.username) {
  model.value.username = props.username
}

if (props.password) {
  model.value.password = props.password
}
const validateEmail = (email: string) => {
  // return email
  //   .toLowerCase()
  //   .match(
  //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  // );
  return true
}

const validEmail = computed(() => {
  let username = model.value.username
  return username && validateEmail(username)
})

const submit = () => {
  if (validInput.value) {
    emitters('doLogin', model.value)
    return
  }

  toast.warning(t('toast.invalid-username-or-password'))
}
const emailPlaceholder = t('input.placeholder.email', { prefix: 'example', domain: 'domain.com' })
</script>
<template>
  <div class="login">
    <div class="login-details">
      <form>
        <label for="userId" :class="{ error: validEmail }">
          {{ $t('input.label.username') }}
          <input
            v-model="model.username"
            @keyup.enter="submit"
            id="userId"
            type="text"
            :placeholder="emailPlaceholder"
            inputmode="email"
            maxlength="60"
            minlength="6"
          />
        </label>
        <label for="password">
          {{ $t('input.label.password') }}
          <input
            v-model="model.password"
            @keyup.enter="submit"
            id="password"
            type="password"
            inputmode="text"
            maxlength="48"
            minlength="8"
          />
        </label>
      </form>
    </div>
    <button class="ok" @click="submit" :disabled="!validInput" :class="{ disabled: !validInput }">
      OK
    </button>
  </div>
</template>
<style scoped>
button.disabled {
  background-color: gray;
  border-color: gainsboro;
}

input {
  width: 100%;
}

.login {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.login-details {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding-top: 8px;
  gap: 8px;
}
</style>
